import isAppWebView from "@hooks/useIsAppWebView";
import ArticleContentAppWebView from "@pages/Article/ArticleContentAppWebView";

import ArticlePageContent, { ArticleContentProps } from "./ArticlePageContent";

const ArticleWrapper = ({ data }: ArticleContentProps): React.ReactElement => {
  const isWebView = isAppWebView();

  if (isWebView) return <ArticleContentAppWebView data={data} />;

  return <ArticlePageContent data={data} />;
};

export default ArticleWrapper;
